import { createReducer, on } from '@ngrx/store';
import {
  getData,
  getGeneratedTranslations,
  saveLanguages,
  setLanguages,
  setTranslations,
  updateTranslations
} from '../actions/translation.actions';

export interface TranslationsState {
  data: any;
}

export const initialState: TranslationsState = {
  data: {}
};

export const translationsReducer = createReducer(
  initialState,
  on(getData, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setLanguages, (state, { languagesRes }) => ({
    ...state,
    ...{ languagesRes }
  })),
  on(saveLanguages, (state, { languagesData }) => ({
    ...state,
    ...languagesData
  })),
  on(getGeneratedTranslations, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setTranslations, (state, { translationsData }) => ({
    ...state,
    ...translationsData
  })),
  on(updateTranslations, (state, { translationsData }) => {
    return {
      ...state,
      ...translationsData
    };
  })
);
